<template>
    <div class="banner">
        <div class="title3 helvetica">Learn more</div>
        <div v-if="downloads" class="downloads-container">
            <a v-for="el in downloads" class="download title5 helvetica" :href="`${directusUrl}/assets/${el.directus_files_id.id}`" target="_blank">
                <span>{{ el.directus_files_id?.title }}</span>
                <IconDownload />
            </a>
        </div>
    </div>
</template>

<script setup lang="ts">
const directusUrl = useDirectusUrl()
defineProps<{ downloads: any[] }>()
</script>

<style lang="scss" scoped>
.banner {
    margin: var(--size-gutter-sections) var(--size-margin-page) 0 var(--size-margin-page);
    background-color: var(--color-sand-light);

    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: var(--size-margin-page);
    padding: var(--size-gutter-default);
    min-height: 166px;

    .title3 {
        color: #404040;
    }

    .downloads-container {
        .download {
            color: var(--color-primary);

            .icon {
                padding-left: var(--size-gutter-small);
            }
        }
    }
}

@media screen and (max-width: 600px) {
    .banner {
        display: flex;
        flex-direction: column;

    }
}
</style>